import { CONFIRMATION_DATA } from 'site-modules/financing/constants/financing';

export const updateCreativeIdForConfirmMode = (trackingParent, formName, isConfirmed) =>
  isConfirmed ? `${trackingParent}-${CONFIRMATION_DATA[formName.toLowerCase()].creativeId}` : trackingParent;
